const USERS_UI_SCHEMA = {
  table: {
    columnSections: [
      {
        key: 'basic',
        title: 'Basic info',
      },
      {
        key: 'role',
        title: 'Role info',
      },
    ],
    items: [
      {
        property: 'employeeId',
        sectionKey: 'basic',
      },
      {
        property: 'positions',
        sectionKey: 'role',
      },
      {
        property: 'locations',
        sectionKey: 'role',
      },
      {
        property: 'groups',
        sectionKey: 'role',
      },
      {
        property: 'email',
        sectionKey: 'basic',
      },
      {
        property: 'phone',
        sectionKey: 'basic',
      },
      {
        property: 'status',
        sectionKey: 'basic',
      },
    ],
  },
};

export default USERS_UI_SCHEMA;
